import { Button } from '@mantine/core';
import { IconFileTypeDocx } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';

interface CenterReportButtonProps {
  researchCenterId: Id;
}

const onDownload = (researchCenterId: Id) => {
  window.open(`/api/research-centers/report/${researchCenterId}/latest/docx`);
};

export function CenterReportButton({ researchCenterId }: CenterReportButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeDocx size="24px" />}
      onClick={() => onDownload(researchCenterId)}
    >
      {t('researchCenters.report.downloadCenter')}
    </Button>
  );
}
